import { DEFAULT_FILTERS } from "../../utils/constant"

const defaultSate = {
    reusableProductionStepsList: [], // for listing just names
    reusableProductionSteps: [], // for listing with parse includes
    reusableProductionStepsPipeline: [], // for pipeline view
    filters: DEFAULT_FILTERS,
    total: 0,
    reusableProductionStep: null,
    supplierItems: [],
    // KFC-565: recipes not updated after the last reusable step edition, null when nothing to show
    rebuildReport: null,
    // KFC-565: recipes being updated after a reusable step edition
    rebuildInProgress: false
}

export default function (state = defaultSate, action) {

    switch (action.type) {
        case "REUSABLE_STEPS_LOADED":
            return {
                ...state,
                reusableProductionSteps: action.reusableProductionSteps,
                supplierItems: action.supplierItems
            }
        case "REUSABLE_STEPS_LIST_LOADED":
            return {
                ...state,
                reusableProductionStepsList: action.reusableProductionSteps,
                supplierItems: action.supplierItems
            }
        case "REUSABLE_STEPS_PIPELINE_LOADED":
            return {
                ...state,
                reusableProductionStepsPipeline: action.reusableProductionSteps,
                supplierItems: action.supplierItems
            }
        case "REUSABLE_STEP_LOADED":
            return {
                ...state,
                reusableProductionStep: action.reusableProductionStep,
                isEdtion: action.isEdition,
                isNew: action.isNew
            }
        case "REUSABLE_STEPS_FILTERS_LOADED":
            return {
                ...state,
                filters: action.filters,
            }
        case "REUSABLE_STEPS_TOTAL_LOADED":
            return {
                ...state,
                total: action.total,
            }
        case "REUSABLE_STEP_REBUILD_REPORT_LOADED":
            return {
                ...state,
                rebuildReport: action.rebuildReport
            }
        case "REUSABLE_STEP_REBUILD_STARTED":
            return {
                ...state,
                rebuildInProgress: true
            }
        case "REUSABLE_STEP_REBUILD_ENDED":
            return {
                ...state,
                rebuildInProgress: false
            }
        case "REUSABLE_STEP_REBUILD_REPORT_CLOSED":
            return {
                ...state,
                rebuildReport: null
            }
        default:
            return {
                ...state
            }
    }
}

// ---------------------------------------- //
// --------------- SELECTOR --------------- //
// ---------------------------------------- //
export const getReusableProductionStepsSelector = (state) => {
    return state.steps.reusableProductionSteps
}
export const getReusableProductionStepsListSelector = (state) => {
    return state.steps.reusableProductionStepsList
}
export const getReusableProductionStepsPipelineSelector = (state) => {
    return state.steps.reusableProductionStepsPipeline
}
export const getReusableProductionStepSelector = (state) => {
    return state.steps.reusableProductionStep
}

export const getIsEditionReusableProductionStepSelector = (state) => {
    return state.steps.isEdtion
}

export const getIsNewReusableProductionStepSelector = (state) => {
    return state.steps.isNew
}

export const getReusableStepsSupplierItemsSelector = (state) => {
    return state.steps.supplierItems
}

export const getReusableStepRebuildReportSelector = (state) => {
    return state.steps.rebuildReport
}

export const getIsReusableStepRebuildInProgressSelector = (state) => {
    return state.steps.rebuildInProgress
}
